// Formats d'affichage selon la langue du client : « 13,1 » et « 14,21 € » en
// français, « 13.1 » et « €14.21 » en anglais.

export const formatDecimal = (value, language, digits = 1) =>
  new Intl.NumberFormat(language, {
    minimumFractionDigits: digits,
    maximumFractionDigits: digits,
  }).format(Number(value) || 0);

export const formatEuros = (value, language) =>
  new Intl.NumberFormat(language, { style: "currency", currency: "EUR" }).format(
    Number(value) || 0
  );
